export const SELECT_NONE_OPTION = {
  label: 'None',
  value: 'null',
};

export const PROCEDURE_OPTIONS = [
  {
    label: 'THA',
    value: 'thr',
  },
  {
    label: 'TKA',
    value: 'tkr',
  },
  {
    label: 'Other',
    value: 'other',
  },
];

export const FALL_WITNESSED_OPTIONS = [
  SELECT_NONE_OPTION,
  {
    label: 'Yes',
    value: true,
  },
  {
    label: 'No',
    value: false,
  },
];
